var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJ = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "5.25rem",
  height: "5.25rem",
  "data-name": "Group 22",
  viewBox: "0 0 142.755 142.755"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "J_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h142.755v142.755H0z",
  "data-name": "Rectangle 25"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 21",
  style: {
    clipPath: "url(#J_svg__a)"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M137.825 28.738 28.739 137.824a16.834 16.834 0 0 1-23.808-23.807L114.017 4.93a16.835 16.835 0 0 1 23.808 23.808",
  "data-name": "Path 12"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M114.017 137.824 4.931 28.738A16.834 16.834 0 1 1 28.738 4.93l109.087 109.086a16.835 16.835 0 0 1-23.808 23.808",
  "data-name": "Path 13"
}))));
export default SvgJ;